import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const assessmentTreatmentGoalsApi = createApi({
  reducerPath: 'assessmentTreatmentGoalsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "/reports",
  }),
  endpoints: (builder) => ({}),
  tagTypes: ["AssessmentGoals"]
});